import { ReactElement, useCallback, useState, useEffect } from 'react';

export interface IFrameProps {
  children?: ReactElement;
  frameBorder?: number;
  id?: string;
  marginHeight?: number;
  marginWidth?: number;
  scrolling?: string;
  src: string;
  width?: string;
  sandbox?: string;
}

/**
 * IFrame can be used to display an IFrame with e2m theming.
 */
export const IFrame = ({ children, src, ...props }: Readonly<IFrameProps>): ReactElement<IFrameProps> => {
  const [height, setHeight] = useState('100%');

  const onWatchEventHandler = useCallback(
    (event: MessageEvent) => {
      if (event.origin === src) {
        const { height: actual } = event.data;
        // Adjust height slightly to account for our footer.
        setHeight(`${actual + 30}px`);
      }
    },
    [src],
  );

  useEffect(() => {
    window.addEventListener('message', onWatchEventHandler);
    return () => window.removeEventListener('message', onWatchEventHandler);
  }, [src, onWatchEventHandler]);

  return (
    <iframe
      src={src}
      style={{
        height,
      }}
      {...props}
    >
      {children}
    </iframe>
  );
};
